<div class="flex flex-col">
  <div class="h-px bg-neutral-300"></div>
  <div
    class="flex cursor-pointer items-start justify-start gap-2 px-6 py-4 focus:bg-neutral-50 focus:outline-none"
    (click)="toggleAccordion()"
    (keydown.enter)="toggleAccordion()"
    (keydown.space)="toggleAccordion()"
    role="button"
    tabindex="0"
  >
    <div class="flex h-7 grow items-center justify-between">
      <div class="text-lg leading-normal font-normal text-primary-text">
        {{ filterName() | translate }}
      </div>
      <svg
        class="transform transition-transform duration-300 ease-in-out"
        [class.rotate-180]="isAccordionOpen"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="transition-opacity duration-300 ease-in-out"
          [class.opacity-0]="isAccordionOpen"
          d="M19 11.5H13V5.5H11V11.5H5V13.5H11V19.5H13V13.5H19V11.5Z"
          fill="#323739"
        />
        <path
          class="transition-opacity duration-300 ease-in-out"
          [class.opacity-100]="isAccordionOpen"
          [class.opacity-0]="!isAccordionOpen"
          d="M5 11.5H19V13.5H5V11.5Z"
          fill="#323739"
        />
      </svg>
    </div>
  </div>
  <div
    class="overflow-hidden transition-all duration-300 ease-in-out"
    [style.height]="isAccordionOpen ? '16rem' : '0'"
    [style.opacity]="isAccordionOpen ? '1' : '0'"
  >
    <ng-content></ng-content>
  </div>
</div>
